module.exports = __webpack_public_path__ + "img/ge.292fa45.svg";